//theme
import "primereact/resources/themes/lara-light-indigo/theme.css";
// import "primereact/resources/themes/lara-dark-indigo/theme.css";
//core
import "primereact/resources/primereact.min.css";
//icons
import "primeicons/primeicons.css";

import { useState } from "react";
import { BrowserRouter, Routes, Route, useParams } from "react-router-dom";

import Login from "./components/login/Login";
import Error from "./components/home/Error";
import Home from "./components/home/Home";
import LandingPage from "./components/home/LandingPage";
import useToken from "./useToken";
import Indexing from "./components/home/Indexing";

function App() {
  const { auth, token, setAuth, setToken } = useToken();

  if (!token) {
    return (
      <BrowserRouter>
        <Routes>
          <Route path="/">
            <Route
              index
              element={<Login setAuth={setAuth} setToken={setToken} />}
            />
            <Route path="/*" element={<Error />} />
          </Route>
        </Routes>
      </BrowserRouter>
    );
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/">
          <Route index element={<Indexing token={token} />} />
          {/* <Route path="/domain/:domain_id" element={<Home token={token} />} /> */}
          <Route path="/*" element={<Error />} />
        </Route>
        <Route path="*" element={<Error />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
